import React from 'react';
import { audiences } from '../data/content';
import { CtaButton } from './CtaButton';
export function AudienceSection() {
  return <section className="bg-white px-4 py-6 md:px-12 md:py-8" data-id="element-1" data-mp="mzx4o3sdofxu">
      <h2 className="mx-auto max-w-[600px] text-center text-[22px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-blue-950 md:text-[30px]" data-id="element-2" data-mp="s02x3m6h26gz">
        Designed for pediatric occupational therapy professionals
      </h2>
      <ul className="mt-4 divide-y divide-slate-200 border-y border-slate-200" data-id="element-3" data-mp="3viw9vwrfera3">
        {audiences.map(a => <li key={a.title} className="grid gap-1 py-3 md:grid-cols-[240px_1fr] md:gap-6" data-id="element-4" data-mp="4ba3hwdboapj">
            <h3 className="text-[14px] font-extrabold uppercase leading-tight text-teal-700 md:text-[15px]" data-id="element-5" data-mp="98saviboyhvf">
              {a.title}
            </h3>
            <p className="text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-6" data-mp="3crbu5vce6de3">{a.text}</p>
          </li>)}
      </ul>
      <p className="mx-auto mt-3 max-w-[600px] text-center text-[13px] leading-[1.4] text-slate-600 md:text-[14px]" data-id="element-7" data-mp="3hols5zdujxdj">
        Primarily designed for children approximately ages 4–10, with individual selection based on functional needs and
        professional assessment.
      </p>
      <div className="mt-4" data-id="element-8" data-mp="uk7pucur0lb7">
        <CtaButton mode="scroll" subtext="Walk into every session with a ready plan — only $26.90 USD" data-id="element-9" data-mp="ujg7i3q5wk2v">
          Yes! I want to plan my sessions in minutes
        </CtaButton>
      </div>
    </section>;
}